export interface PreviewVideoSyncSnapshot {
  targetTime: number;
  playing: boolean;
}

export function shouldSeekPreviewVideoElement(
  previous: PreviewVideoSyncSnapshot | null | undefined,
  targetTime: number,
  mediaCurrentTime: number,
  isPlaying: boolean
): boolean {
  if (!previous) return true;

  const wasPlaying = Boolean(previous.playing);
  const justStarted = isPlaying && !wasPlaying;
  const jumpedBackward = targetTime < previous.targetTime - 0.15;
  const jumpedFarForward = targetTime > previous.targetTime + 2;
  const drift = Math.abs(mediaCurrentTime - targetTime);

  return isPlaying
    ? justStarted || jumpedBackward || jumpedFarForward || drift > 0.5
    : drift > 0.08;
}
